// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".banner-wrapper[data-v-377b6548]{background-color:#2a2c40;border-bottom:1px solid #a8a8a8;position:relative}.btn-close[data-v-377b6548]{position:absolute;right:10px}@media screen and (max-width:960px){.btn-close[data-v-377b6548]{bottom:0;right:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
